import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../../Organization/Types';
import Lima from './Lima';

interface Props {
  licenseFamily: LicenseFamily;
  activationsRemaining: Maybe<number>;
  title: string;
  newLicenseAllocations: number;
  allocatedLicenses: number;
}

function Message({
  licenseFamily,
  activationsRemaining,
  title,
  newLicenseAllocations,
  allocatedLicenses,
}: Props) {
  switch (licenseFamily) {
    case 'lima':
      return (
        <Lima
          activationsRemaining={activationsRemaining}
          title={title}
          newLicenseAllocations={newLicenseAllocations}
          allocatedLicenses={allocatedLicenses}
        />
      );
    case 'classic':
      return <></>;
  }
}

export default observer(Message);
